// Archivo: src/layouts/MainLayout.js

import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';

// NUEVO: Icono para el botón de "Volver Arriba"
const ArrowUpIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
    </svg>
);


export default function MainLayout({ children }) {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  
  // NUEVO: Estado para controlar la visibilidad del botón de scroll
  const [isScrollButtonVisible, setScrollButtonVisible] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    if (isSidebarOpen) {
      setSidebarOpen(false);
    }
  };
  
  // NUEVO: Efecto para mostrar u ocultar el botón de "Volver Arriba"
  useEffect(() => {
    const toggleVisibility = () => {
      // Si el usuario ha bajado más de 300px, muestra el botón
      if (window.pageYOffset > 300) {
        setScrollButtonVisible(true);
      } else {
        setScrollButtonVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    // Limpia el listener cuando el componente se desmonta
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // NUEVO: Función para hacer scroll suave hacia arriba
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        document.body.style.overflow = 'auto';
      } else {
        document.body.style.overflow = isSidebarOpen ? 'hidden' : 'auto';
      }
    };

    handleResize(); 
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.body.style.overflow = 'auto'; 
    };
  }, [isSidebarOpen]);

  return (
    // CAMBIO ESTÉTICO: Fondo con un gradiente sutil para mayor profundidad visual
    <div className="bg-gradient-to-br from-white to-gob-fondo font-sans">
      <Header onMenuButtonClick={toggleSidebar} />
      <Sidebar isOpen={isSidebarOpen} />
      
      <div className="relative z-40">
        <Footer />
      </div>

      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-10 bg-black bg-opacity-50 md:hidden"
          onClick={closeSidebar}
          aria-hidden="true"
        ></div>
      )}

      <main className={`transition-all duration-300 ease-in-out min-h-screen ${isSidebarOpen ? 'md:ml-64' : 'ml-0'} pt-16 pb-12`}>
        <div className="p-4 sm:p-6 md:p-8">
          {children}
        </div>
      </main>

      {/* NUEVA FUNCIONALIDAD: Botón de "Volver Arriba" */}
      {isScrollButtonVisible && (
        <button
            onClick={scrollToTop}
            className="fixed bottom-20 right-4 md:bottom-16 md:right-8 z-50 p-3 bg-gob-azul-oscuro text-white rounded-full shadow-lg hover:bg-gob-azul-medio focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gob-azul-oscuro transition-all duration-300 transform hover:scale-110 animate-fade-in-up"
            aria-label="Volver arriba"
        >
            <ArrowUpIcon />
        </button>
      )}
    </div>
  );
}

